// extracted by mini-css-extract-plugin
module.exports = {"link":"profileLink_link__Ndr4l","name":"profileLink_name__1XHqM","image":"profileLink_image__1dCEG"};